import React from 'react';
import { Col } from 'react-bootstrap';

import BoxConteudo from '../../../../../components/BoxConteudo';
import CustomRow from '../../../../../components/CustomRow';
import Input from '../../../../../components/InputNew';

interface ObservacoesGeraisProps {
  fechado: boolean;
  value: string;
  onChange: (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => void;
}

const ObservacoesGerais: React.FC<ObservacoesGeraisProps> = ({
  fechado,
  value,
  onChange,
}) => {
  return (
    <BoxConteudo boxTitulo="Observações Gerais" fechado={fechado}>
      <CustomRow style={{ marginTop: '-15px' }}>
        <Col>
          <Input
            id="observacoes"
            type="textarea"
            name="observacoes"
            linhas={5}
            value={value}
            onChange={onChange}
          />
        </Col>
      </CustomRow>
    </BoxConteudo>
  );
};

export default ObservacoesGerais;
